// @flow
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ContactWrapper from 'components/contact/ContactWrapper';
import type { DispatchProps, StateProps } from 'components/contact/ContactWrapper';
import type { DispatchType, StateType } from 'types/Actions';
import { fetchThemes, fetchQuestions } from 'actions/faqActions';
import { fetchPageList } from 'actions/pageActions';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      faqThemes: state.faqState.themes,
      template: state.pageListState,
      title: state.pageListState.title,
      excerpt: state.pageListState.excerpt,
      sidebar_content: state.pageListState.sidebar_content,
      featured_media: state.pageListState.featured_media,
      banniere: state.settingsState.banniere,
      clubName: state.settingsState.title,
      placeholder: state.settingsState.placeholder,
      rencontresLive: state.rencontreLiveState.rencontres ? Object.keys(state.rencontreLiveState.rencontres).length : 0
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchThemes: () => dispatch(fetchThemes()),
      fetchQuestions: () => dispatch(fetchQuestions()),
      fetchPageList: (slug: string) => dispatch(fetchPageList(slug))
    })
  )(ContactWrapper)
);
